

import React from 'react';
import { connect } from 'react-redux';
import FormatNum from '../../../Utils/generalUtils.js';
import { FaTv } from 'react-icons/fa';
import { setRegisterDetails, setCurrentPage, setOrderDetails} from '../../../General/Actions';
import { Button } from 'reactstrap';
import LoadingAnimation from '../../../Utils/loadingAnimation.js';
import { FiWifi } from 'react-icons/fi';
import Constants from '../../../Utils/constants.json';

class UpgradeOfferCartComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            skeltonScreenLoading: true,
            isLoading: false,
            totalMonthlyCharges: 0,
            upgradedActiveTab: true,
            tab: "upgraded",
            currentOfferCharge: 0,
            heightSet: 0
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.registerDetails !== prevProps.registerDetails) {
            this.calculateTotalCharge();
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        if (Object.keys(this.props.registerDetails.customize).length == 0) {
            this.setState({ selectedAddons: [] })
        } else {
            this.setState({ selectedAddons: this.props.registerDetails.customize.devices })
        }
        this.calculateTotalCharge();
        this.calculateCurrentTotalCharge();
    }

    handleScroll = () => {
        this.setState({ heightSet: window.scrollY });
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.handleScroll);
    }

    calculateCurrentTotalCharge() {
        let sum = 0;
        for (var i = 0; i < this.props.registerDetails.activeAddons.length; i++) {
            sum = sum + (parseFloat(this.props.registerDetails.activeAddons[i].addonPrice || 0))
        }
        //this.state.currentOfferCharge = this.props.registerDetails.offers.offerAmount;
        this.setState({ "dummy": "dummy" })
    }

    calculateTotalCharge() {
        let sum = 0;
        var currentObj = this.props.registerDetails.offers;
        for (var i = 0; i < this.props.registerDetails.customize.addons.length; i++) {
            sum = sum + (parseFloat(this.props.registerDetails.customize.addons[i].offerAmount || 0) * this.props.registerDetails.customize.addons[i].count)
        }

        sum = parseFloat(this.props.registerDetails.offers.offerAmount)

        if(currentObj && currentObj.taxArray){
            for(var k=0; k < currentObj.taxArray.length; k++){
                sum = sum + parseFloat(currentObj.taxArray[k].taxPrice)
            }
        }
      
        if(currentObj && currentObj.discountArray){
            for(var j=0; j < currentObj.discountArray.length; j++){
                sum = sum - parseFloat(currentObj.discountArray[j].discountPrice)
            }
        }
        
        this.state.currentOfferCharge = parseFloat(this.props.registerDetails.offers.offerAmount);
        if(this.props.cache.currentPlanDetails.isContractExpired == false){
            sum = sum + parseFloat(this.props.registerDetails.contractDetails.price)
        } 

        this.state.totalMonthlyCharges = sum;
       
        this.setState({ dummy: "dummy" });
    }

    cartBackButtonClicked() {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
        if (this.props.currentPage.pageName == "services") {
            window.location.reload();
        }
        if (this.props.currentPage.pageName == "confirmation") {
            this.props.setCurrentPage("pageName", "services");
        }
        if (this.props.currentPage.pageName == "summary") {
            this.props.setCurrentPage("pageName", "confirmation");
        }
    }

    cartNextButtonClicked() {
        window.scroll({ top: 0, left: 0, behavior: 'smooth' });
       
        if (this.props.currentPage.pageName === "services") {
            this.props.setCurrentPage("pageName", "confirmation");
        }
        if (this.props.currentPage.pageName == "confirmation") {
            this.props.setCurrentPage("pageName", "summary");
        }
    }

    tablinkClicked(type) {
        if (type == "upgraded") {
            this.setState({
                tab: type,
                upgradedActiveTab: true,
                currentActiveTab: false
            });
        } else {
            this.setState({
                tab: type,
                upgradedActiveTab: false,
                currentActiveTab: true
            });
        }
    }

    populateAddonCharges() {
        const allAddonDetails = this.props.registerDetails.customize.addons.map((item, key) => {
                return (
                    <div className="col-12 row m-0 pb-1 pt-2 p-0 align-items-center" key={key}>
                        <div className="col-8">
                        <div className="subLabel textOverFlowHidden_">{item.name} &nbsp;
                            {parseInt(item.count) > 1 ?
                                <span>({item.count})</span>
                                :
                                null
                            }
                        </div>
                        <div className="subLabel textOverFlowHidden_" style={{fontWeight:300,fontSize:12,color:'#6d6d6d'}}>{item.description}</div>
                        </div>
                        <div className="col-4 text-right" style={{ color: '#231F20', fontSize: 14, fontWeight: 600 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(item.count * item.offerAmount || 0)}</div>
                    </div>
                )
        });
        if (this.props.registerDetails.customize.addons.length > 0) {
            return (<div className="">{allAddonDetails}</div>)
        } else {
            return (<div className=""><div className="col-md-12 mx-auto row py-2" style={{ color: 'gray', fontSize: 12 }}>No addons are selected</div></div>);
        }
    }

    populateOfferCharges() {
                return (
                    <div className="col-12 row p-0 m-0">
                        <div className="col-12 row p-0 m-0 pb-1 pt-2 align-items-center">
                            <div className="col-8">
                                <div className="subLabel textOverFlowHidden_">{this.props.registerDetails.offers.name}
                                </div>
                                {Object.keys(this.props.registerDetails.contracts).length > 0 ?
                                    <div className="subLabel textOverFlowHidden_ py-1">({this.props.registerDetails.offers.contract_details.name})</div>
                                    : null
                                }
                                <div className="subLabel textOverFlowHidden_" style={{ fontWeight: 300, fontSize: 12, color: '#6d6d6d' }}>{this.props.registerDetails.offers.description}</div>
                            </div>
                            <div className="col-4 text-right" style={{ color: '#231F20', fontSize: 14, fontWeight: 600 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(this.props.registerDetails.offers.offerAmount || 0)}</div>
                        </div>
                        {this.props.registerDetails.offers.discountArray.map((itemArr, key) => {
                            return (
                                <div className="col-12 p-0 m-0 row" key={key}>
                                    <div className="col-8 subLabel textOverFlowHidden_" style={{ color: '#58595B', fontSize: 11, fontWeight: 300 }}>{itemArr.discountName}</div>
                                    <div className="col-4 text-right" style={{ color: '#000000', fontSize: 11, fontWeight: 300 }}>${itemArr.discountPrice}</div>
                                </div>
                                )
                            })
                        }
                        {this.props.registerDetails.offers.taxArray.map((itemArr, key) => {
                            return (
                                <div className="col-12 p-0 m-0 row" key={key}>
                                    <div className="col-8 subLabel textOverFlowHidden_" style={{ color: '#58595B', fontSize: 11, fontWeight: 300 }}>{itemArr.taxName}</div>
                                    <div className="col-4 text-right" style={{ color: '#000000', fontSize: 11, fontWeight: 300 }}>${itemArr.taxPrice}</div>
                                </div>
                                )
                            })
                        }
                    </div>
                )
    }

    populateCurrentOfferDetails() {
        return (
            <div className="row col-md-12 p-0 m-0">
                <div className="offerChargesDiv col-md-12 p-0">
                        <div className="col-md-12 offerChargesHeading">
                        {
                         this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() 
                         ?
                         <span><FiWifi style={{ fontSize: 20, color: '#33495F' }} /></span>
                         : null
                         }
                          {
                         this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() 
                         ?
                         <span><FaTv style={{ fontSize: 20, color: '#33495F' }} /></span>
                         : null
                         }
                        <span className="ml-2">{this.props.cache.currentPlanDetails.serviceName}</span></div>
                            <div>
                                <div className="col-12 row p-0 m-0 pb-1 pt-2 align-items-center">
                                    <div className="col-8 subLabel textOverFlowHidden_">{this.props.cache.currentPlanDetails.activePlanName}</div>
                                    <div className="col-4 text-right" style={{ color: '#231F20', fontSize: 14, fontWeight: 600 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(this.props.cache.currentPlanDetails.allBasePlanServiceCharge)}</div>
                                </div>
                                <div className="col-12 row px-0 m-0 pb-2">
                                    <div className="col-12" style={{ color: '#6D6D6D', fontSize: 12 }}>{this.props.cache.currentPlanDetails.activePlanDesc}</div>
                                </div>
                            </div>
                    </div>
            </div>
        )
    }

    populateCartDetails() {
        return (
            <div>
                {this.props.registerDetails.isConfirmationReached ?
                    <div>
                        <div className="row col-md-12 p-0 m-0 mx-auto">
                            <div className="offerChargesDiv col-md-12 p-0">
                                <div className="col-md-12 offerChargesHeading">

                                            {
                                this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() 
                                ?
                                <span><FiWifi style={{ fontSize: 20, color: '#33495F' }} /></span>
                                : null
                                }
                                {
                                this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() 
                                ?
                                <span><FaTv style={{ fontSize: 20, color: '#33495F' }} /></span>
                                : null
                                }
                        <span className="ml-2">{this.props.cache.currentPlanDetails.serviceName}</span></div>  
                                <div className="col-md-12 p-0">
                                    {/* <div className="col-md-12 row m-0 pb-1 pt-2 px-0 pb-2">
                                        <div className="col-md-8">
                                        <div className="subLabel textOverFlowHidden_" style={{fontSize:14,color:'#404042'}}>{this.props.cache.currentPlanDetails.activePlanName}
                                        </div>
                                        <div className="subLabel textOverFlowHidden_" style={{fontWeight:300,fontSize:12,color:'#6d6d6d'}}>{this.props.cache.currentPlanDetails.activePlanDesc}</div>
                                        </div>
                                        <div className="col-md-4 text-right" style={{ color: '#33495F', fontSize: 14, fontWeight: 500 }}>{Constants.dollarSign}{this.props.cache.currentPlanDetails.activePlanAmount}.{this.props.cache.currentPlanDetails.activePlanDecimal}</div>
                                    </div> */}
                                    <div className="col-md-12 p-0 pb-2" style={{backgroundColor:'#ffffff'}}>
                                        {this.populateOfferCharges()}
                                    </div>
                                    {/* <div className="col-md-12 p-0 pb-2" style={{backgroundColor:'#ffffff'}}>
                                        {this.populateAddonCharges()}
                                    </div> */}
                                    <div className="col-12 row m-0 totalChargeDiv align-items-center">
                                        <div className="col-8" style={{ color: '#33495F', fontSize: 14,fontWeight:600 }}>Subtotal</div>
                                        <div className="col-4 text-right" style={{ color: '#33495F', fontWeight: 'bold', fontSize: 12 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(this.state.currentOfferCharge)}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                       
                    {this.props.cache.currentPlanDetails.isContractExpired == false ? 
                        <div className="row col-md-12 p-0 m-0 mx-auto mt-2">
                            <div className="offerChargesDiv col-md-12 p-0">
                                <div className="col-md-12 offerChargesHeading">               
                                <span className="subLabel">{this.props.locales.otherChargesHeadingInUpgradeOfferCart}</span></div>  
                                <div className="col-md-12 p-0">
                                    <div className="col-12 row m-0 totalChargeDiv align-items-center">
                                        <div className="col-8">
                                        <div className="textOverFlowHidden_" style={{fontSize:14,color:'#404042', fontWeight: 400 }}>{this.props.locales.contractViolationLabelInUpgradeOfferCart}
                                        </div>
                                        </div>
                                        <div className="col-4 text-right" style={{ color: '#33495F', fontSize: 14, fontWeight: 400 }}>{Constants.dollarSign}{this.props.registerDetails.contractDetails.price}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null }

                        <div className="col-md-12 row p-0 m-0">
                            <div className="col-md-12 row px-0 m-0 totalChargeDiv">
                                <div className="col-12 row mt-2 align-items-center p-0 mx-auto">
                                    <div className="col-8" style={{ color: '#231F20', fontWeight: 600,fontSize:16 }}>Total</div>
                                    <div className="col-4 text-right" style={{ color: '#231F20', fontWeight: 600, fontSize: 16 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(parseFloat(this.state.totalMonthlyCharges))}</div>
                                </div>
                                {/* <div className="col-md-12 m-0" style={{ fontSize: 10, color: '#6d6d6d' }}>
                                    <div style={{ width: 200 }}>(Next month’s charges + estimated taxes and fees)</div>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="row col-md-12 p-0 m-0 mx-auto">
                            <div className="offerChargesDiv col-md-12 p-0">
                                <div className="col-md-12 offerChargesHeading">
                        {
                         this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() 
                         ?
                         <span><FiWifi style={{ fontSize: 20, color: '#33495F' }} /></span>
                         : null
                         }
                          {
                         this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() 
                         ?
                         <span><FaTv style={{ fontSize: 20, color: '#33495F' }} /></span>
                         : null
                         }
                        <span className="ml-2">{this.props.cache.currentPlanDetails.serviceName}</span></div>
                                <div className="col-md-12 p-0">
                                    {this.populateOfferCharges()}
                                </div>
                               
                                <div className="col-12 row m-0 totalChargeDiv align-items-center">
                                    <div className="col-8" style={{ color: '#33495F', fontSize: 14,fontWeight:500 }}>Subtotal</div>
                                    <div className="col-4 text-right" style={{ color: '#33495F', fontSize: 14 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                                </div>
                            </div>
                        </div>

                        {/* <div className="col-md-12 row py-1 px-0 m-0 totalChargeDiv mt-3" style={{ backgroundColor: '#f7f7f7' }}>
                            <div className="col-md-12 row m-0 p-0">
                                <div className="col-md-8" style={{ color: '#000000', fontWeight: 500,fontSize:14 }}>Grand Subtotal</div>
                                <div className="col-md-4 text-right" style={{ color: '#000000', fontWeight: 500, fontSize: 14 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                            </div>
                        </div> */}

                        {this.props.cache.currentPlanDetails.isContractExpired == false ?
                        <div className="row col-md-12 p-0 m-0 mx-auto mt-2">
                            <div className="offerChargesDiv col-md-12 p-0">
                                <div className="col-md-12 offerChargesHeading">               
                                <span className="subLabel">{this.props.locales.otherChargesHeadingInUpgradeOfferCart}</span></div>  
                                <div className="col-md-12 p-0">
                                    <div className="col-12 row m-0 totalChargeDiv align-items-center">
                                        <div className="col-8">
                                        <div className="textOverFlowHidden_" style={{fontSize:14,color:'#404042', fontWeight: 400 }}>{this.props.locales.contractViolationLabelInUpgradeOfferCart}
                                        </div>
                                        </div>
                                        <div className="col-4 text-right" style={{ color: '#33495F', fontSize: 14, fontWeight: 400 }}>{Constants.dollarSign}{this.props.registerDetails.contractDetails.price}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        : null }

                        <div className="col-12 row m-0 totalChargeDiv align-items-center p-0">
                            <div className="col-12 row mt-2 mx-auto p-0">
                                <div className="col-8" style={{ color: '#231F20', fontWeight: 600, fontSize:16 }}>Total</div>
                                <div className="col-4 text-right" style={{ color: '#231F20', fontWeight: 600, fontSize: 16 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(this.state.totalMonthlyCharges)}</div>
                            </div>
                            {/* <div className="col-md-12 m-0" style={{ fontSize: 10, color: '#6d6d6d' }}>(Next month’s charges + estimated taxes and fees)</div> */}
                        </div>
                      
                    </div>
                }
            </div>
        )
    }

    render() {
        return(  
            <div className="row ml-sm-0 mx-auto">
                {this.state.isLoading ? <LoadingAnimation isVisible={true} /> : null}
                {this.componentContent()}
            </div>
        )
}

componentContent(){
    if (Object.keys(this.props.registerDetails.offers).length == 0) {
        return (
            <div className="changePlanCartMainContainer col-md-12 row pb-3" style={this.state.heightSet > window.innerHeight ? {position: 'fixed', width: '30%', bottom: '50%'} : {}}>
                <div className="py-2" style={{ fontSize: 18, fontWeight: 500 }}>{this.props.locales.currentOfferSectionHeadingInCart}</div>
                <div className="offerChargesDiv col-md-12 p-0">
                <div className="col-md-12 offerChargesHeading">
                    {
                        this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForInternet.toUpperCase() 
                        ?
                        <span><FiWifi style={{ fontSize: 20, color: '#33495F' }} /></span>
                        : null
                    }
                    {
                         this.props.cache.currentPlanDetails.serviceName.toUpperCase() === this.props.locales.productFamilyNameForVideo.toUpperCase() 
                         ?
                         <span><FaTv style={{ fontSize: 20, color: '#33495F' }} /></span>
                         : null
                    }
                    <span className="ml-2">{this.props.cache.currentPlanDetails.serviceName}</span></div>
                    <div>
                        <div className="col-md-12 row p-0 m-0 pb-1 pt-2">
                            <div className="col-md-8 subLabel textOverFlowHidden_">{this.props.cache.currentPlanDetails.activePlanName}</div>
                            <div className="col-md-4 text-right" style={{ color: '#231F20', fontSize: 14, fontWeight: 600 }}>{Constants.dollarSign}{FormatNum.formatNumberToStandardForm(this.props.cache.currentPlanDetails.allBasePlanServiceCharge)}</div>
                        </div>
                        <div className="col-md-12 row px-0 m-0 pb-2">
                            <div className="col-md-12" style={{ color: '#6D6D6D', fontSize: 12 }}>{this.props.cache.currentPlanDetails.activePlanDesc}</div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
    else {
        return(
            <div className="row outerDiv align-items-center">
                {this.props.registerDetails.isConfirmationReached ?
                    <div className="changePlanCartMainContainer col-md-12 row m-0 p-0">
                        <div className="col-md-12 py-1" style={{marginLeft:1}}>
                            <div style={{fontSize:18,fontWeight:500}}>{this.props.locales.orderDetailsHeadingCartInAddSubscription}</div>
                        </div>
                        <div className="col-md-12 cartDetailsContainer mb-3">{this.populateCartDetails()}</div>
                    </div>
                :
                <div className="changePlanCartMainContainer col-md-12 row m-0 p-0" style={this.state.heightSet > window.innerHeight ? {position: 'fixed', width: '30%', bottom: '50%'} : {}}>
                        <div className="col-12 row justify-content-around mb-2 p-0" style={{marginLeft:1}}>
                            <div className={this.state.currentActiveTab == true ? "tabHeader activeTabHeader  col-6 p-0 py-2" : "tabHeader  col-6 p-0 py-2"} onClick={() => { this.tablinkClicked('current') }} style={{ color: '#33495F' }} >{this.props.locales.currentOfferSectionHeadingInCart}</div>
                            <div className={this.state.upgradedActiveTab == true ? "tabHeader activeTabHeader col-6 p-0 py-2" : "tabHeader  col-6 p-0 py-2"} onClick={() => { this.tablinkClicked('upgraded') }} style={{ color: '#33495F' }}>{this.props.locales.upgradedOfferSectionHeadingInCart}</div>
                        </div>
                        {this.state.tab == "upgraded" ? 
                            <div className="col-12 cartDetailsContainer mb-3">{this.populateCartDetails()}</div>                     
                        :
                            <div className="col-12 cartDetailsContainer mb-3">{this.populateCurrentOfferDetails()}</div> 
                        }

                    <div className="col-md-12 d-none d-sm-block p-0 mx-auto">
                        <div className="col-md-12 row justify-content-end py-3 m-0" style={{ backgroundColor: '#FFFFFF' }}>
                            <Button className="" style={{ padding: '8px 45px', background: '#0049A5', borderRadius: 4, border: 0, color: '#ffffff', fontWeight: 500, fontSize: 14 }} onClick={() => { this.cartNextButtonClicked() }}>
                                {this.props.locales.upgradeOfferCartNextBtnText}
                            </Button>
                        </div>
                    </div>

                    </div>
                }
            </div>
        )
        }
    }
}


const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        registerDetails: state.registerDetails,
        currentPage: state.currentPage,
        cache: state.cache,
        orderDetails: state.orderDetails,
        feasibilityResposnse: state.feasibilityResposnse
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        },
        setCurrentPage: function (key, payload) {
            dispatch(setCurrentPage(key, payload));
        },
        setOrderDetails: function (key, payload) {
            dispatch(setOrderDetails(key, payload));
        },
    }
}

const UpgradeOfferCartComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(UpgradeOfferCartComponent)


export default UpgradeOfferCartComponentContainer;

